/* eslint-disable @typescript-eslint/no-explicit-any */
import { create } from "zustand";
import { persist } from "zustand/middleware";

type UserSettingsStore = {
  drawerOpen: boolean;
  setDrawerOpen: (drawerOpen: boolean) => void;

  drawerReporteOpen: boolean;
  setDrawerReporteOpen: (drawerReporteOpen: boolean) => void;

  globalSettings: any;
  toggleGlobalSettings: () => void;

  language: string;
  setLanguage: (language: string) => void;
};

export const useUserSettingsStore = create<UserSettingsStore>()(
  persist(
    (set) => ({
      drawerOpen: false,
      setDrawerOpen: (drawerOpen: boolean) => set({ drawerOpen }),

      drawerReporteOpen: false,
      setDrawerReporteOpen: (drawerReporteOpen: boolean) =>
        set({ drawerReporteOpen }),

      globalSettings: true,
      toggleGlobalSettings: () =>
        set((state) => ({ globalSettings: !state.globalSettings })),

      language: "en",
      setLanguage: (language: string) => set({ language }),
    }),
    {
      name: "user-settings-storage",
      partialize: (state) => ({
        globalSettings: state.globalSettings,
        language: state.language,
      }),
    }
  )
);

export const useDrawerOpen = () => {
  const drawerOpen = useUserSettingsStore((state) => state.drawerOpen);
  const setDrawerOpen = useUserSettingsStore((state) => state.setDrawerOpen);

  return { drawerOpen, setDrawerOpen };
};

export const useDrawerReporteOpen = () => {
  const drawerReporteOpen = useUserSettingsStore(
    (state) => state.drawerReporteOpen,
  );
  const setDrawerReporteOpen = useUserSettingsStore(
    (state) => state.setDrawerReporteOpen,
  );

  return { drawerReporteOpen, setDrawerReporteOpen };
};

export const useGlobalSettings = () => {
  const globalSettings = useUserSettingsStore((state) => state.globalSettings);
  const toggleGlobalSettings = useUserSettingsStore(
    (state) => state.toggleGlobalSettings,
  );

  return { globalSettings, toggleGlobalSettings };
};

export const useLanguageSettings = () => {
  const language = useUserSettingsStore((state) => state.language);
  const setLanguage = useUserSettingsStore((state) => state.setLanguage);

  return { language, setLanguage };
};
